//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

export const POST_PREVIEW_MEDIA_WIDTH = 334;
export const POST_PREVIEW_FORM_WIDTH = 547;
export const POST_PREVIEW_TAB_WIDTH = 968;

export const POST_PREVIEW_NO_MEDIA_WIDTH = 234;
export const POST_PREVIEW_INVALID_MEDIA_WIDTH = 292;

export const FACEBOOK_MAX_IMAGE_HEIGHT = POST_PREVIEW_MEDIA_WIDTH;
export const FACEBOOK_LINK_METADATA_MISSING_TRAY_HEIGHT = 80;

export const INSTAGRAM_STORY_MEDIA_HEIGHT = 594;
export const INSTAGRAM_REELS_ASPECT_RATIO = 9 / 16;
export const INSTAGRAM_REELS_MEDIA_HEIGHT = Math.floor(
  POST_PREVIEW_MEDIA_WIDTH / INSTAGRAM_REELS_ASPECT_RATIO,
);

export const TWITTER_MEDIA_HEIGHT = 361;

export const POST_PREVIEW_BORDER_STYLE = `${theme.borderWidths[1]} solid ${theme.colors.gray2}`;

export const TIKTOK_VERTICAL_ASPECT_RATIO = 9 / 16;
export const TIKTOK_VIDEO_PREVIEW_WIDTH = POST_PREVIEW_MEDIA_WIDTH;
export const TIKTOK_VIDEO_PREVIEW_HEIGHT = Math.floor(
  TIKTOK_VIDEO_PREVIEW_WIDTH / TIKTOK_VERTICAL_ASPECT_RATIO,
);

export const VIDEO_THUMBNAIL_TOOLTIP =
  'Switch to Automatic posting to edit your cover image.';

export const POST_PREVIEW_TOO_MANY_MEDIA_TOOLTIP =
  'Cover images can only be added for single video uploads. Cover images are not supported for carousel posts';

export const POST_PREVIEW_NO_MEDIA_TEXT =
  'Select media above to preview your post.';

export const COVER_IMAGE_TOOLTIP =
  "We recommend a 9:16 ratio, otherwise Instagram will crop the image and use the middlemost 9:16 rectangle for your reel's cover photo. If you share a reel to your feed, Instagram will crop the image and use the middlemost 1:1 square for your post's cover photo.";
